module.exports = __webpack_public_path__ + "static/media/n-continuum-sample.56e2a77b.png";